<template>
  <div>
    <!-- Contenedor Bienvenida Padres -->
    <div
      class="padres-container"
    >

      <div
        ref="texto0Ref"
        class="texto-container texto-novia"
      >
      <span class="nombre-novia1">Anna Karen</span>
<span class="apellidos-novios">Salinas Barrientos</span>
    <br>
        <span class="starlove">&</span>
        <br>


        <span class="nombre-novia1">Hiram Esau </span>
        <span class="apellidos-novios"> Mendoza Burnias </span>

      </div>
      <br>
     
      <!-- Texto 2 -->
  

  

  </div>
  </div>
</template>
    
  <script>
  import { onMounted, ref, nextTick } from 'vue';
  import 'animate.css';

  export default {
    name: 'BienvenidaPadresPage',
    setup() {
      const texto1Ref = ref(null);
      const texto2Ref = ref(null);
      const texto3Ref = ref(null);
      const texto0Ref = ref(null);
      const texto4Ref = ref(null);


      const observeElement = (element) => {
        if (element.value) {
          const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: [0.1],
          };
  
          const observerCallback = (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                element.value.classList.add('animate__animated', 'animate__fadeInUp');
                element.value.style.opacity = '1';
                element.value.style.transform = 'translateY(0)';
  
                element.value.addEventListener('animationend', () => {
                  element.value.classList.remove('animate__animated', 'animate__fadeInUp');
                }, { once: true });
              } else {
                element.value.style.opacity = '0';
                element.value.style.transform = 'translateY(50px)';
              }
            });
          };
  
          const observer = new IntersectionObserver(observerCallback, observerOptions);
          observer.observe(element.value);
        }
      };
  
      onMounted(async () => {
        await nextTick();
        observeElement(texto0Ref);
        observeElement(texto4Ref);

        observeElement(texto1Ref);
        observeElement(texto2Ref);
        observeElement(texto3Ref);
      });
  
      return { texto0Ref, texto1Ref, texto2Ref, texto3Ref,texto4Ref };
    },
  };
  </script>
  
  <style scoped>
@font-face {
  font-family: 'FeelingPassionate';
  src: url('@/assets/fonts/passionate.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: block; /* Espera a que la fuente esté cargada antes de mostrarla */
}


@font-face {
  font-family: 'Starlove';
  src: url('../assets/fonts/starlove.ttf') format('truetype'); /* Asegúrate de usar la extensión correcta */
  font-weight: normal;
  font-style: normal;
}
  /* Contenedor Bienvenida Padres */
  .padres-container {
    position: relative;
    width: 100%;
    height: 135hv;
    text-align: center;
    background-image: url('../assets/i3.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 30px;
    padding-bottom: 15px;

    transform: translateY(50px);

  }
  /* Estilo para los textos */
  .texto-container {
    padding:5px;
    margin: 0px 0;
    opacity: 0;
    font-size: 18px;
    font-family: 'Dancing Script', sans-serif;
  font-weight: 350;    color: #333;
    border-radius: 10px;
    z-index: 2;
    
    width: 90%;
    white-space: nowrap; /* Evita que el texto se divida en varias líneas */
    transform: translateY(50px);
  }

  .novia {
    letter-spacing: 2px; /* Espaciado entre letras */

    font-size: 24px;
    font-family: 'Dancing Script', sans-serif;
  font-weight: 350;    color: #333;
}
  
  .texto-container.animate__animated {
    transform: translateY(0);
    opacity: 1;
  }
  



/* Estilo para la palabra Novia */
.titulo-novia {
  font-size: 16px;
  color: #333333d4;
  font-family: "Lusitana", serif;

  
}

/* Estilo para la palabra Novio */
.titulo-novio {
  font-size: 16px;
  color: #333333d4;
  font-family: "Lusitana", serif;

}
.text{
  margin-top: -20px;
  font-size: 20px;
  letter-spacing: 0.5px; /* Ajusta este valor según el espaciado que desees */
  color: #9c916b !important; 

  font-family: "Lusitana", serif;
  font-weight: 350;    

}

/* Estilo para los nombres de los novios */
.nombre-novia{
  font-family: "Lusitana", serif;
  font-weight: 200;
  font-weight: 350;    color: #333333d4;
  font-size: 18px;
}

.nombre-novio {
  font-family: "Lusitana", serif;
  font-weight: 200;
  font-weight: 350;    color: #333333d4;
  font-size: 18px;


}

.starlove {
  margin-top:-30px;
  font-family: 'starlove', cursive; /* Cambia 'cursive' por la fuente por defecto si deseas */
  font-size: 44px; /* Ajusta el tamaño según lo necesites */
  color: #93806d; /* Ajusta el color según tu preferencia */
  top:-20px;
}
/*cruz*/
.icono {
  color: #726c55 !important; /* Color de la cruz */
  font-size: 8px; /* Ajusta este valor según el tamaño deseado */
  vertical-align: middle; /* Alinea el ícono verticalmente con el texto */
  margin-left: 5px; /* Espacio entre el texto y el ícono */
}

 .texto-container2{
  padding-bottom: 20px;
    margin: 10px 0;
    opacity: 0;
    font-size: 20px;
    font-family: 'Dancing Script', sans-serif;
  font-weight: 350;    color: #333;
    border-radius: 10px;
    z-index: 2;
    width: 90%;
    margin-top:0;
    margin-bottom: 15px;
    transform: translateY(50px);
 }
 /* Contenedor principal para las columnas */


 .texto-container3{
  padding-bottom: 40px;
    margin: 10px 0;
    opacity: 0;
    font-size: 20px;
  font-weight: 350;    color: #333;
    border-radius: 10px;
    z-index: 2;
    width: 90%;
    margin-bottom: 60px;

    margin-top:0;
    transform: translateY(50px);
 }

 .texto-container4{
  padding-bottom: 40px;

  margin: 10px 0;
  opacity: 0;
  font-size: 20px;
  font-family: 'Dancing Script', sans-serif;
  font-weight: 350;
  color: #333;
  border-radius: 10px;
  z-index: 2;
  width: 90%;
  margin-top: 0;
  margin-bottom: 60px;
  transform: translateY(50px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* Sombra sutil */
  background: #fff; /* Fondo blanco para la tarjeta */
  transition: all 0.3s ease; /* Suavizar la transición */
}
 .nombre-novioo{
  font-size: 24px;
    font-family: 'Dancing Script', sans-serif;
  font-weight: 350;    color: #333;

 }


 .nombre-novia1, .apellidos-novios {
  display: block;
  text-align: center;
}

.nombre-novia1 {
  font-size: 40px; /* Tamaño grande para los nombres */
  font-family: "Lusitana", serif;
  font-weight: 700;
  color: #897850;

  letter-spacing: 2px;
}

.apellidos-novios {
  font-size: 30px; /* Tamaño un poco más pequeño */
  font-family: "Hearth Stone", sans-serif;
  font-weight: 400;
  line-height: 1.5; /* Ajusta la separación entre líneas */

  color: #cfcfcf; /* Color gris claro */
}

  </style>
  